import { ClientScoreHealthRangeProps } from '..';
import { ClientScoreHealthRange } from '../ScoreHealthRange';
import { DEBT_RATE_SCORE_HEALTH_RANGE_BREAKPOINTS } from './constants';
import { DEBT_RATE_SCORECARD_ELEMENT_SYMBOL } from '../../../Scorecard';

export function ClientDebtRateScoreHealthRange(props: Omit<ClientScoreHealthRangeProps, 'breakpoints' | 'element'>) {
  return (
    <ClientScoreHealthRange
      {...props}
      element={DEBT_RATE_SCORECARD_ELEMENT_SYMBOL}
      breakpoints={DEBT_RATE_SCORE_HEALTH_RANGE_BREAKPOINTS}
    />
  );
}
